// @flow

import _ from 'lodash';
import React, { Component } from 'react';
import Accordion from 'client/components/accordion/accordion';
import Checkmark from 'client/components/checkmark';
import EmailSubscriptionContainer from 'client/components/subscribe/email';
import HeroContainer from 'client/components/heroContainer';
import Panel from 'client/components/accordion/panel';
import CONTENTFUL_ENTRY_ID from 'client/constants/contentfulEntry';
import {
  COVID19_TAX_TAB_CLICK,
  COVID19_TAX_EMAIL_SUBSCRIBED,
} from 'client/constants/amplitudeTracker';
import COLORS from 'client/constants/colors';
import { Tracking } from 'web-core/src/tracking';
import IntroSection, { type IntroType } from './shared/introSection';
import ResourcesNav, { type NavType } from './shared/resourcesNav';
import { trackAccordionClick } from './utils/tracking';

import '../styles/guidePage.scss';

type Props = {
  fetchContentful: Function,
  contentfulData: {
    accordion: Array<{
      title: string,
      content: string,
    }>,
    accordionHeader: string,
    emailSubscription: {
      header: string,
      description: string,
    },
    hero: Object,
    intro: IntroType,
    nav: NavType,
  },
};

class TaxGuide extends Component<Props> {
  componentDidMount() {
    this.props.fetchContentful(CONTENTFUL_ENTRY_ID.COVID_19_TAX_GUIDE);
  }

  render() {
    const {
      contentfulData: { accordion, accordionHeader, emailSubscription, hero, intro, nav },
    } = this.props;

    if (!accordion) return null;

    return (
      <div className="tax-guide-page guide-page-container">
        <HeroContainer base="tax-guide" {...hero} />
        <div className="content-container">
          {intro && <IntroSection intro={intro} />}
          <div className="gray-content-box">
            <h4 className="header bold pad-bottom">{emailSubscription.header}</h4>
            <div className="pad-bottom">{emailSubscription.description}</div>
            <EmailSubscriptionContainer
              lists={['covidTaxEmailSubscription']}
              className="focus-white-color email-subscription-form"
              id="covidTaxEmailSubscription"
              submitHandler={() => Tracking.track(COVID19_TAX_EMAIL_SUBSCRIBED)}
              subscribeSuccessIcon={<Checkmark checked />}
              subscribeSuccessStyle={{
                display: 'flex',
                alignItems: 'center',
                fontSize: '16px',
                fontWeight: '600',
                marginBottom: '2rem',
                color: COLORS.NAVY_2,
              }}
              buttonClassName="primary oep-hover"
              buttonLabel={{ path: 'common.cta.sendMeUpdates' }}
              subscribedLabel={{ path: 'common.label.emailSubscribedShort' }} />
          </div>
          <h3 className="pad-y-2">{accordionHeader}</h3>
          <Accordion onChange={state => trackAccordionClick(COVID19_TAX_TAB_CLICK, state)}>
            {_.map(accordion, item => (
              <Panel key={item.title} title={<span>{item.title}</span>}>
                <div dangerouslySetInnerHTML={{ __html: `${item.content}` }} />
              </Panel>
            ))}
          </Accordion>
          {nav && <ResourcesNav nav={nav} />}
        </div>
      </div>
    );
  }
}

export default TaxGuide;
